/**
 * Build a browser-openable URL for a file under the API `uploads/` tree.
 * Preserves subfolders (vehicleOnboardings, driverOnboardings, …).
 */
export function resolveUploadUrl(apiBase, raw) {
  if (!raw) return null;
  const s = String(raw).trim();
  if (/^(blob:|data:)/i.test(s)) return s;

  const b = String(apiBase || "").trim().replace(/\/$/, "");
  if (!b) return null;

  if (/^https?:\/\//i.test(s)) {
    try {
      const u = new URL(s);
      return `${b}${u.pathname}${u.search || ""}`;
    } catch {
      return s;
    }
  }

  let p = s.replace(/^\/+/, "").replace(/\\/g, "/");
  const uploadsIdx = p.toLowerCase().indexOf("uploads/");
  if (uploadsIdx >= 0) {
    p = p.slice(uploadsIdx);
  } else if (!/^uploads\//i.test(p)) {
    p = `uploads/${p.replace(/^uploads\/?/i, "")}`;
  }
  const encoded = p
    .split("/")
    .map((seg, i) => (i === 0 ? seg : encodeURIComponent(decodeURIComponent(seg))))
    .join("/");
  return `${b}/${encoded}`;
}
